import Meander from "./Meander"
import StepCard from "./StepCard"

const STEPS = [
  {
    heading: "It starts with a prompt.",
    body: "Write, run, iterate. Templates, versioning, tool calls: knowledge bases, APIs, MCP, other prompts, and beyond. The craft of prompt engineering, with the discipline of real tooling.",
    spark: "orange",
  },
  {
    heading: "One prompt becomes many.",
    body: "Build workflows. Build agents. Scripts, conditions, loops, parallel execution – wire your logic, run it. No framework required.",
    spark: "yellow",
  },
  {
    heading: "Then you test it.",
    body: "Evaluations are workflows – same editor, same building blocks. Feed a dataset in, put your prompt or workflow under test, score the outputs with assertions.",
    spark: "purple",
  },
  {
    heading: "Then you run it at scale.",
    body: "Trigger runs via API. Dedicated capacity, parallel execution: a pipeline that used to take an hour finishes in minutes.",
    spark: "orange",
  },
] as const

export default function Staircase() {
  return (
    <section id="features" className="mx-auto max-w-250 px-6 py-8 sm:py-10">
      <div className="relative mx-auto hidden h-155 max-w-225 md:block">
        <Meander variant="desktop" />

        <div className="absolute top-5 left-10 z-10 max-w-75">
          <StepCard {...STEPS[0]} />
        </div>
        <div className="absolute top-20 left-120 z-10 max-w-75">
          <StepCard {...STEPS[1]} />
        </div>
        <div className="absolute top-85 left-10 z-10 max-w-75">
          <StepCard {...STEPS[2]} />
        </div>
        <div className="absolute top-95 left-125 z-10 max-w-75">
          <StepCard {...STEPS[3]} />
        </div>
      </div>
      <div className="relative md:hidden">
        <Meander variant="mobile" />

        <div className="relative z-10 flex flex-col gap-8">
          <div className="mr-8">
            <StepCard {...STEPS[0]} />
          </div>
          <div className="ml-8">
            <StepCard {...STEPS[1]} />
          </div>
          <div className="mr-8">
            <StepCard {...STEPS[2]} />
          </div>
          <div className="ml-8">
            <StepCard {...STEPS[3]} />
          </div>
        </div>
      </div>
    </section>
  )
}
